<template>
     
     <div class="closeButton">⏺</div>
     
</template>

<style scoped>
.closeButton{
    position: absolute; 
    top: 0px;
    right: 5px; 
    cursor: default;
    padding: 5px 10px;
    color: var(--g1);
    border-radius: 100px;
    cursor: pointer;
    font-size: 20px;
    transition: all 0.2s ease;
    user-select: none;
}

.closeButton:hover{
    color: var(--g4);
}
</style>